import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef, useState } from 'react';
import type { Dispatch, SetStateAction } from 'react';
import { RollingNumber } from './rolling-number';
import { cn } from '@/lib/utils';
type NumericInputProps = {
  value: number | null;
  setValue: Dispatch<SetStateAction<number | null>>;
  min?: number;
  max?: number;
  step?: number;
  className?: string;
  disabled?: boolean;
  animateValue?: boolean;
};
const NumericInput = t0 => {
  const $ = _c(50);
  const {
    value,
    setValue,
    min,
    max,
    step: t1,
    className,
    disabled: t2,
    animateValue: t3
  } = t0;
  const step = t1 === undefined ? 1 : t1;
  const disabled = t2 === undefined ? false : t2;
  const animateValue = t3 === undefined ? false : t3;
  const inputRef = useRef(null);
  const [isEditing, setIsEditing] = useState(false);
  let t4;
  if ($[0] !== disabled || $[1] !== max || $[2] !== setValue || $[3] !== step) {
    t4 = () => {
      if (disabled) {
        return;
      }
      setValue(prev => {
        if (prev === null) {
          return null;
        }
        const newValue = prev + step;
        if (max !== undefined && newValue > max) {
          return prev;
        }
        return newValue;
      });
    };
    $[0] = disabled;
    $[1] = max;
    $[2] = setValue;
    $[3] = step;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const increment = t4;
  let t5;
  if ($[5] !== disabled || $[6] !== min || $[7] !== setValue || $[8] !== step) {
    t5 = () => {
      if (disabled) {
        return;
      }
      setValue(prev_0 => {
        if (prev_0 === null) {
          return null;
        }
        const newValue_0 = prev_0 - step;
        if (min !== undefined && newValue_0 < min) {
          return prev_0;
        }
        return newValue_0;
      });
    };
    $[5] = disabled;
    $[6] = min;
    $[7] = setValue;
    $[8] = step;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const decrement = t5;
  let t6;
  let t7;
  if ($[10] !== min || $[11] !== setValue) {
    t6 = () => {
      const handleBlur = () => {
        setTimeout(() => {
          setValue(prev_1 => {
            if (prev_1 === null) {
              return min ?? 0;
            }
            return prev_1;
          });
        }, 200);
      };
      const currentRef = inputRef.current;
      if (currentRef) {
        currentRef.addEventListener("blur", handleBlur);
        return () => {
          currentRef.removeEventListener("blur", handleBlur);
        };
      }
    };
    t7 = [min, setValue];
    $[10] = min;
    $[11] = setValue;
    $[12] = t6;
    $[13] = t7;
  } else {
    t6 = $[12];
    t7 = $[13];
  }
  useEffect(t6, t7);
  let t8;
  if ($[14] !== className) {
    t8 = cn("flex items-center content-start", className);
    $[14] = className;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  const t9 = disabled || value === null || min !== undefined && (value === null || value <= min);
  let t10;
  if ($[16] !== decrement || $[17] !== t9) {
    t10 = <button type="button" onClick={decrement} disabled={t9} className="flex h-10 w-6 items-center justify-start hover:cursor-pointer disabled:opacity-50 -ml-3 pl-3 box-content" aria-label="Decrease value">-</button>;
    $[16] = decrement;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  const t11 = value === null ? "" : value;
  let t12;
  if ($[19] !== max || $[20] !== min || $[21] !== setValue) {
    t12 = e => {
      const newValue_1 = e.target.value === "" ? null : Number.parseInt(e.target.value);
      if (newValue_1 === null || !Number.isNaN(newValue_1)) {
        if (newValue_1 === null || (min === undefined || newValue_1 >= min) && (max === undefined || newValue_1 <= max)) {
          setValue(_prev => newValue_1);
        }
      }
    };
    $[19] = max;
    $[20] = min;
    $[21] = setValue;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  let t14;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = () => setIsEditing(true);
    t14 = () => setIsEditing(false);
    $[23] = t13;
    $[24] = t14;
  } else {
    t13 = $[23];
    t14 = $[24];
  }
  const t15 = animateValue && !isEditing && "text-transparent";
  let t16;
  if ($[25] !== t15) {
    t16 = cn("flex items-center justify-center w-24 py-2 border border-zinc-400 rounded-[0.5rem] text-center no-spinner", t15);
    $[25] = t15;
    $[26] = t16;
  } else {
    t16 = $[26];
  }
  let t17;
  if ($[27] !== disabled || $[28] !== max || $[29] !== min || $[30] !== step || $[31] !== t11 || $[32] !== t12 || $[33] !== t16) {
    t17 = <input ref={inputRef} type="number" value={t11} onChange={t12} min={min} max={max} step={step} disabled={disabled} onFocus={t13} onBlur={t14} className={t16} aria-label="Numeric value" />;
    $[27] = disabled;
    $[28] = max;
    $[29] = min;
    $[30] = step;
    $[31] = t11;
    $[32] = t12;
    $[33] = t16;
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  let t18;
  if ($[35] !== animateValue || $[36] !== isEditing || $[37] !== value) {
    t18 = animateValue && <span className={cn("pointer-events-none absolute inset-0 flex items-center justify-center", isEditing && "invisible")} aria-hidden="true"><RollingNumber value={value === null ? "" : String(value)} /></span>;
    $[35] = animateValue;
    $[36] = isEditing;
    $[37] = value;
    $[38] = t18;
  } else {
    t18 = $[38];
  }
  let t19;
  if ($[39] !== t17 || $[40] !== t18) {
    t19 = <div className="relative">{t17}{t18}</div>;
    $[39] = t17;
    $[40] = t18;
    $[41] = t19;
  } else {
    t19 = $[41];
  }
  const t20 = disabled || value === null || max !== undefined && (value === null || value >= max);
  let t21;
  if ($[42] !== increment || $[43] !== t20) {
    t21 = <button type="button" onClick={increment} disabled={t20} className="flex h-10 w-6 items-center justify-end text-xl font-medium text-white hover:cursor-pointer disabled:opacity-50 -mr-3 pr-3 box-content" aria-label="Increase value">+</button>;
    $[42] = increment;
    $[43] = t20;
    $[44] = t21;
  } else {
    t21 = $[44];
  }
  let t22;
  if ($[45] !== t10 || $[46] !== t19 || $[47] !== t21 || $[48] !== t8) {
    t22 = <div className={t8}>{t10}{t19}{t21}</div>;
    $[45] = t10;
    $[46] = t19;
    $[47] = t21;
    $[48] = t8;
    $[49] = t22;
  } else {
    t22 = $[49];
  }
  return t22;
};
NumericInput.displayName = 'NumericInput';
export { NumericInput };